export default __webpack_public_path__ + "static/media/english-to-latvian-logo.ddc41941.png";